import { render } from "./SearchActions.vue?vue&type=template&id=1b366c15&ts=true"
import script from "./SearchActions.vue?vue&type=script&lang=ts"
export * from "./SearchActions.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__